import { ShapeDetectionResult } from '@editor/interfaces/shape'

class ShapeDetectionError extends Error {
  result: ShapeDetectionResult[]

  constructor(message: string, result: ShapeDetectionResult[]) {
    super(message)
    this.name = 'ShapeDetectionError'
    this.result = result
  }
}

export default ShapeDetectionError
